<template>
  <app-panel>
    <div slot="panel-header" class="app-panel-collapse-small__header">
      <h3 :class="titleClass">{{title}}</h3>
      <i
        aria-hidden="true"
        @click="toggle"
        class="fas app-panel-collapse-small__toggle-icon"
        :class="toggleClass"
      />
    </div>
    <b-collapse
      :class="bodyClass"
      id="collapse1"
      v-model="show"
      slot="panel-body">
      <slot name="panel-body"></slot>
    </b-collapse>
  </app-panel>
</template>

<script>
import AppPanel from './AppPanel';

export default {
  components: {
    AppPanel,
  },
  props: {
    title: {
      type: String,
    },
    bodyClass: {
      type: String,
      default: 'app-panel-collapse-small__body',
    },
    titleClass: {
      type: String,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    toggleClass() {
      return this.show ? 'fa-angle-up' : 'fa-angle-down';
    },
  },
  methods: {
    toggle() {
      this.show = !this.show;
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"

.app-panel-collapse-small
  &__header
    display: flex
    justify-content: space-between
    align-items: center
  &__toggle-icon
    font-size: 20px
  +media-min-lg()
    &__toggle-icon
      display: none
    ::v-deep &__body.collapse
      display: initial !important
  +media-min-md()
  +media-min-lg()
</style>
